import { marked } from "marked";
import TurndownService from "turndown";
import { SHEET_FENCE_RE, sheetToHTMLTable, sheetToMarkdown } from "@/lib/sheetEngine";

const BLOCK_RE = /<(p|div|h[1-6]|ul|ol|li|strong|em|u|s|blockquote|br|a|table)[\s>]/i;

export function looksLikeHtml(s) {
  return BLOCK_RE.test(String(s || ""));
}

function escapeAttr(json) {
  return String(json).replace(/&/g, "&amp;").replace(/"/g, "&quot;");
}
function unescapeAttr(s) {
  return String(s).replace(/&quot;/g, '"').replace(/&amp;/g, "&");
}

// Convierte los bloques ```notacora-sheet``` (legado) en <div data-notacora-sheet="...">.
function fencesToDivs(content) {
  return String(content).replace(SHEET_FENCE_RE, (m, body) => {
    try {
      const o = JSON.parse(body.trim());
      return `<div data-notacora-sheet="${escapeAttr(JSON.stringify({ id: o.id, cells: o.cells }))}"></div>`;
    } catch { return ""; }
  });
}

// Prepara el contenido guardado (HTML nuevo o Markdown legado) para el editor visual.
export function toEditorHtml(content) {
  const withDivs = fencesToDivs(content || "");
  if (looksLikeHtml(content || "")) return withDivs;
  return marked.parse(withDivs);
}

const SHEET_DIV_RE = /<div[^>]*data-notacora-sheet="([^"]*)"[^>]*>\s*<\/div>/g;

function readCells(attr) {
  try { return JSON.parse(unescapeAttr(attr)).cells; } catch { return null; }
}

// Reemplaza las hojas embebidas del HTML por tablas HTML (para imprimir a PDF).
export function htmlSheetsToTables(html) {
  return String(html).replace(SHEET_DIV_RE, (m, attr) => {
    const cells = readCells(attr);
    return cells ? sheetToHTMLTable(cells) : "";
  });
}

let _td = null;
function turndown() {
  if (_td) return _td;
  _td = new TurndownService({ headingStyle: "atx", bulletListMarker: "-", codeBlockStyle: "fenced" });
  _td.addRule("notacoraSheet", {
    filter: (node) => node.nodeName === "DIV" && node.getAttribute("data-notacora-sheet"),
    replacement: (_content, node) => {
      const cells = readCells(node.getAttribute("data-notacora-sheet"));
      return cells ? "\n\n" + sheetToMarkdown(cells) + "\n\n" : "";
    },
  });
  _td.addRule("underline", { filter: ["u"], replacement: (content) => content });
  return _td;
}

// Convierte el HTML del editor a Markdown (para backend PDF / convertir a mapa).
export function htmlToMarkdown(html) {
  return turndown().turndown(String(html || ""));
}
